<template>
  <div>
    <div class="home-head home-head-page">
      <TopHeader></TopHeader>
    </div>
    <div class="case case6 caseContain">
      <div class="caseTitle">
        <div class="container">
          <h3>应用案例</h3>
          <ul>
            <li class="caBg1">
              <a @click="gotoCase1" herf="#">
                <span>
                  <em>IDC服务商</em>
                  <i>IDC机房运维分析监控</i>
                </span>
              </a>
            </li>
            <li class="caBg2">
              <a @click="gotoCase2" herf="#">
                <span>
                  <em>
                    某上市
                    <b class="pSec"></b>零售企业
                  </em>
                  <i>
                    全业务可视化
                    <b class="pSec"></b>统计分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg6">
              <a @click="gotoCase3_1" herf="#">
                <span>
                  <em>
                    某交通管理部门
                    <b class="pSec"></b>
                  </em>
                  <i>交通流量业务可视化统计分析</i>
                </span>
              </a>
            </li>
            <li class="caBg3">
              <a @click="gotoCase4" herf="#">
                <span>
                  <em>运营商</em>
                  <i>
                    用户标签可视化
                    <b class="pSec"></b>聚合分析
                  </i>
                </span>
              </a>
            </li>
            <li class="caBg4">
              <a @click="gotoCase3_2" herf="#">
                <span>
                  <em>某海事局</em>
                  <i>船舶追越分析</i>
                </span>
              </a>
            </li>
            <li class="caBg5 active">
              <a @click="gotoCase3_3" herf="#">
                <span>
                  <em>
                    智能电网
                    <b class="pSec"></b>运检
                  </em>
                  <i>
                    -大数据设备画
                    <b class="pSec"></b>像及应用
                  </i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="caseDetail">
        <div class="container">
          <div class="caseDetailS">
            <span class="caseImg">
              <span></span>
              <em>智能电网运检</em>
              <i>-大数据设备画像及应用</i>
              <b></b>
            </span>
            <div class="caseCon">
              <div class="cPage1">
                <h4>项目背景</h4>
                <p>该电网目前面临数据融合程度低，缺少数据挖掘的有效手段、状态评价预警体系不完善、辅助运维决策深度不够等现状；设备精细化管控工作缺少系统性的支撑信息；无法有效指导设备风险防范和治理工作，运维效率低；突出的表现就是“数据海量，信息缺乏，决策无力”。</p>
                <p>我公司针对当前问题，引入设备画像的方法，通过机器学习，相关性分析等技术手段，实现设备状态准确评估，及时预警和准确决策。将有效提升设备运行效率，降低设备风险。</p>
              </div>
              <div class="cPage2">
                <h4>需求分析</h4>
                <h5>从背景上来看，我们把该公司的需求分为以下几个方面：</h5>
                <ol type="1">
                  <li>各个不同系统之间海量变压器数据资源的整合;</li>
                  <li>从整合的数据资源中挖掘出高价值的信息;</li>
                  <li>结合业务特点建立设备标签库，设置标签规则;</li>
                  <li>建立设备画像系统，直观展现设备缺陷故障问题;</li>
                  <li>建立设备关联关系，识别设备家族化疑似家族性缺陷;</li>
                  <li>建立设备画像管控平台，提供设备精细化管理预案。</li>
                </ol>
              </div>
              <div class="cPage3">
                <h4>目标与价值</h4>
                <table>
                  <thead>
                    <tr>
                      <th>目标</th>
                      <th>价值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>全面整合数据资源，挖掘出高
                          <i class="pSec"></i>价值数据
                        </p>
                      </td>
                      <td>
                        <p>
                          完成非结构化数据管理
                          <i class="pSec"></i>完成海量历史数据的整理与挖掘
                          <i class="pSec"></i>提升系统数据质量与数据管理水平
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>建立设备标签库，完成设备
                          <i class="pSec"></i>画像系统
                        </p>
                      </td>
                      <td>
                        <p>
                          完成电力系统专用数据词典
                          <i class="pSec"></i>建立设备标签库，建立标签算法模型
                          <i class="pSec"></i>完成设备画像系统，直观呈现设备状况
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <i class="K56"></i>建立设备关联关系，进行设备
                          <i class="pSec"></i>状态与寿命预测
                        </p>
                      </td>
                      <td>
                        <p>
                          展示各种缺陷之间的关联性，识别家族性缺陷
                          <i class="pSec"></i>预测缺陷及设备寿命，提供对应解决预案
                          <i class="pSec"></i>完成管控平台，提供设备精细化管控决策基础
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
.case {
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>

<script>
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer.vue";
export default {
  name: "case3-3",
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {
    this.$nextTick().then(
      function() {
        var loginR = document
          .getElementsByClassName("right-selection")[0]
          .getElementsByTagName("div");
        loginR[0].className = "new_login new_login_bcon3";
        loginR[1].className = "new_login new_login_bcon4";
      }.bind(this)
    );
  },
  methods: {
    gotoAbout: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "about" });
    },
    gotoScenarios: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "scenarios" });
    },
    gotoCase1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case1" });
    },
    gotoCase2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case2" });
    },
    gotoCase3_1: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_1" });
    },
    gotoCase3_2: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_2" });
    },
    gotoCase3_3: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case3_3" });
    },
    gotoCase4: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "case4" });
    }
  }
};
</script>
